import "./events-archive.scss";
import "../../../js/core";
import "./critical/events-ajax";
import "./critical/clickmeeting-api";
import "./critical/events-hidden-fields";
import setBlogSubscribeModalHandlers from "../../../../assets/src/eos/js/modals/setBlogSubscribeModalHandlers";

setBlogSubscribeModalHandlers('#modalSubscribeSent');